import { TrendingUp, Users, Target } from "lucide-react";

export function BackgroundSection() {
  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl text-gray-900">
            ご推進の背景
          </h2>
          <div className="w-24 h-1 bg-black mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            AI・デジタル技術の急速な進化により、企業には業務の効率化と高度化が求められています。
            <br className="hidden md:block" />
            中小企業がこれに対応するためには、社員一人ひとりのAIリテラシー向上=DX人材化が必要です。
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <TrendingUp className="w-8 h-8 text-black" />
            </div>
            <h3 className="text-xl mb-3 text-gray-900">技術進化の加速</h3>
            <p className="text-gray-600">
              AI・デジタル技術の急速な進化により、業務の効率化と高度化が求められています
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="w-8 h-8 text-black" />
            </div>
            <h3 className="text-xl mb-3 text-gray-900">人材スキル向上</h3>
            <p className="text-gray-600">
              社員一人ひとりのAIリテラシー向上とDX人材化が企業の競争力に直結
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Target className="w-8 h-8 text-black" />
            </div>
            <h3 className="text-xl mb-3 text-gray-900">効果的な解決策</h3>
            <p className="text-gray-600">
              助成金を活用することで、低コストで効果的な社員教育を実現
            </p>
          </div>
        </div>
        
        <div className="bg-gray-50 p-8 rounded-xl">
          <h3 className="text-2xl mb-4 text-gray-900">本プログラムの特徴</h3>
          <p className="text-gray-700 text-lg">
            本プログラムでは、厚生労働省の「人材開発支援助成金（リスキリング支援コース）」を活用し、
            低コストで効果的な社員教育を可能にするAI/DX研修をご提供します。
          </p>
        </div>
      </div>
    </section>
  );
}